import React from 'react';

const inputStyles = {
  backgroundColor: ' #fefefe',
  border: '1px solid #ccc',
  color: '#0a0a0a',
  fontSize: '14px',
} as React.CSSProperties;

interface filterItemProps {
  type: string;
  label: string;
  options: any;
  onChangeGetProductData: (value: string, item: string) => void;
}

export const FilterItem: React.FC<filterItemProps> = ({ label, onChangeGetProductData, options, type }) => {
  return (
    <div className="input-container flex flex-row gap-2 mb-2 mt-2 w-60" key={type}>
      <select
        className="relative w-full h-8 box-border block overflow-visible p-1 mb-2 text-base rounded"
        id={type}
        name={type}
        onChange={e => onChangeGetProductData(e.target.value, type)}
        style={inputStyles}
      >
        <option value="">Select {label}</option>
        {type == 'country' ? (
          <>
            {options.map(country => {
              return (
                <option key={country.code} value={country.code}>
                  {country.country_name}
                </option>
              );
            })}
          </>
        ) : (
          <>
            {options.map(type => {
              return (
                <option key={type} value={type}>
                  {type}
                </option>
              );
            })}
          </>
        )}
      </select>
    </div>
  );
};
